import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { decideScopeParams } from "@/lib/scopeParams";
import { useLeagueSeasonStore } from "@/state/useLeagueSeasonStore";

/**
 * Applique `?league=&season=` au store puis retire les deux paramètres
 * (`replace`), pour que les liens du tiroir d'engagements ouvrent la cible à la
 * bonne portée, survivent à un rechargement et se partagent. Aucune restauration
 * de l'ancienne portée : le sélecteur montre la nouvelle, comme après un choix
 * manuel.
 */
export function useScopeFromUrl(
  leagueIds: string[] | null | undefined,
  seasons: string[] | null | undefined,
): void {
  const location = useLocation();
  const navigate = useNavigate();
  const setLeague = useLeagueSeasonStore((s) => s.setCurrentLeagueId);
  const setSeason = useLeagueSeasonStore((s) => s.setCurrentSeason);

  useEffect(() => {
    const decision = decideScopeParams(location.pathname, location.search, { leagueIds, seasons });
    if (decision.kind !== "apply") return;
    if (decision.season) setSeason(decision.season);
    if (decision.leagueId) setLeague(decision.leagueId);
    navigate({ pathname: location.pathname, search: decision.search, hash: location.hash }, { replace: true });
  }, [location.pathname, location.search, location.hash, leagueIds, seasons, navigate, setLeague, setSeason]);
}
